<template>
  <div class="form__field">
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <a class="button button--bordered button--primary" @click="submit()">
      {{ field.title }}
      <span class="button__icon icon-right-open-big"></span>
    </a>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-button",
  methods: {
    submit: function() {
      this.$parent[this.field.name]();
    }
  }
};
</script>
